import * as actions from "../Constants/actionTypes";
import { AlertError } from "../../Utils/alertUtils";

const initState = {

    // Video Category
    isLoading: false,
    data: [],
};

const myReducer = (state = initState, action) => {
    switch (action.type) {
        // get payment log
        case actions.AT_GET_VIDEO_CATEGORY_REQUEST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case actions.AT_GET_VIDEO_CATEGORY_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                data: action.payload
            };
        }
        case actions.AT_GET_VIDEO_CATEGORY_FAILURE: {
            const { error } = action.payload;
            AlertError(error);
            return {
                ...state,
                isLoading: false,
                data: initState.data
            };
        }
        default:
            return state;
    }
};

export default myReducer;
